import { render, staticRenderFns } from "./SoundChart.vue?vue&type=template&id=600edd78&"
import script from "./SoundChart.vue?vue&type=script&lang=js&"
export * from "./SoundChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports